import { render, staticRenderFns } from "./Finished.vue?vue&type=template&id=0df50541&"
import script from "./Finished.vue?vue&type=script&lang=ts&"
export * from "./Finished.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports